import _objectWithoutPropertiesLoose from "@babel/runtime/helpers/esm/objectWithoutPropertiesLoose";
const _excluded = ["disabled", "task", "onClick"];
import { useContext, useState } from 'react';
import { Button } from 'foundations-components/transitional/components/Button';
import { LockedIcon } from 'foundations-assets';
import { useTaskLink } from '../../../hooks/hub';
import InviteSeatsContext from 'growth-invite-components/contexts/InviteSeatsContext';
import UsageLimitPopover from './UsageLimitPopover';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { useUserManagementUpgradeKey } from '../../../hooks/upgradeKey';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const InviteTaskButton = _ref => {
  let {
      disabled,
      task,
      onClick
    } = _ref,
    buttonProps = _objectWithoutPropertiesLoose(_ref, _excluded);
  const [isInviteLimitPopoverOpen, setIsInviteLimitPopoverOpen] = useState(false);
  const {
    id,
    link,
    key,
    linkText,
    openLinkInNewTab
  } = task;
  const taskLink = useTaskLink(link, id, task.handholdingEnabled, task.handholdingGroupKeyOverride, task.handholdingSource);
  const inviteSeats = useContext(InviteSeatsContext);
  const {
    hasInviteSeats = true,
    inUseSeats,
    totalSeats
  } = inviteSeats || {};
  const userManagementUpgradeKey = useUserManagementUpgradeKey();
  return /*#__PURE__*/_jsx(UsageLimitPopover, {
    description: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "setup-guide-components.checklist.upgrade.invites.description"
    }),
    onClose: () => setIsInviteLimitPopoverOpen(false),
    open: isInviteLimitPopoverOpen,
    planLimitLabel: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "setup-guide-components.checklist.upgrade.invites.planLimit",
      options: {
        limitNumber: totalSeats
      }
    }),
    planUsageLabel: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "setup-guide-components.checklist.upgrade.invites.planUsage",
      options: {
        usedNumber: inUseSeats,
        limitNumber: totalSeats
      }
    }),
    taskKey: key,
    title: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "setup-guide-components.checklist.upgrade.invites.title"
    }),
    upgradeCta: /*#__PURE__*/_jsx(FormattedMessage, {
      message: "setup-guide-components.checklist.upgrade.invites.upgradeCta"
    }),
    upgradeKey: userManagementUpgradeKey,
    usageCurrent: inUseSeats,
    usageLimit: totalSeats,
    children: /*#__PURE__*/_jsxs(Button, Object.assign({
      disabled: disabled,
      external: openLinkInNewTab,
      href: hasInviteSeats ? taskLink : undefined,
      onClick: evt => {
        if (typeof onClick === 'function') {
          onClick(evt);
        }
        if (!hasInviteSeats) {
          setIsInviteLimitPopoverOpen(true);
        }
      }
    }, buttonProps, {
      children: [hasInviteSeats === false && /*#__PURE__*/_jsx(LockedIcon, {}), linkText]
    }))
  });
};
export default InviteTaskButton;